import * as E from './errors';
export function colorHexToRGB (hex : string) {
	// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
	const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	hex = hex.replace(shorthandRegex, (match, r, g, b) => {
		<any>match;
		return (r + r + g + g + b + b);
	});
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return (result ? {
			r: parseInt(result[1] || '0', 16),
			g: parseInt(result[2] || '0', 16),
			b: parseInt(result[3] || '0', 16)
		} : null
	);
};
export type TColorRGBCoefArray = (
	[ number, number, number ] |
	[ number, number, number, number ]
);
export function colorRGBCoefArrayToRGB8BitsArray(color : TColorRGBCoefArray) {
	const colors = (<[number, number, number ]>color.slice(0, 3)).map(x => Math.round(x * 255));
	if (color.length === 4) { // rgba
		colors.push(color[3]);
	}
	return (colors);
};
export function colorRGBCoefArrayToRGB8BitsString(color : TColorRGBCoefArray) {
	const colors = colorRGBCoefArrayToRGB8BitsArray(color);
	let method = 'rgb';
	if (color.length === 4) {
		method += 'a';
	}
	return (`${method}(${ colors.join(', ') })`);
};

export function computeChrominance (color : any) {
	if (
		(typeof color !== 'string') ||
		(color[0] !== '#')
	) {
		throw E.user('Unsupported color type!', {	color	});
	}
	const rgb = colorHexToRGB(color);
	if (!rgb) {
		throw E.user('Invalid color!', { color });
	}
	const chrominance = (
		(0.2126 * (rgb.r / 255)) +
		(0.7152 * (rgb.g / 255)) +
		(0.0722 * (rgb.b / 255))
	);
	return (chrominance);
};
export const transparentBase64PNGPixel = (
	'data:image/png;base64,iVBORw0KGg' +
	'oAAAANSUhEUgAAAAEAAAABCAQAAAC1HA' +
	'wCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2q' +
	'gAAAAASUVORK5CYII='
);
